// This file is JS (not TS) because it is required from Gatsby Node CommonJS
// (sites/petsafe/src/node/bazaarvoice-reviews.js). Same pattern as
// generateProductSlug.js and algoliaCollectionConfigBase.js: Node-side
// `require('@repo/utils/...')` does not resolve `.ts` without a loader.
// Keep this file TS-free so build-time BV ID resolution stays shared with
// the runtime widget helpers. Types live in formatReviewSku.d.ts.

export const formatReviewSku = sku => sku?.replaceAll('/', '_');
